module.exports = __webpack_public_path__ + "static/media/media.cb88d0df.svg";